import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useTranslation = (tag) => {
  const culture = useSelector(state => state.globalization.language);
  const translationsCache = useSelector(state => state.globalization.translationsCache);
  const currentCultureTranslationsArr = translationsCache[culture];
  const [termTranslated, setTermTranslated] = useState(tag);

  // Verifica se o termo está cadastrado no Globalization na cultura selecionada
  const existingTagInfos = currentCultureTranslationsArr
    ? currentCultureTranslationsArr.filter(termsObj => termsObj.term === tag) : null;

  // Se o termo estiver cadastrado no Globalization e tiver tradução no idioma, usa esse valor
  // Se o termo não estiver cadastrado no Globalization, usa o valor da tag como tradução
  // Assim como se estiver cadastrado no Globalization, mas não tiver tradução no idioma
  useEffect(() => {
    if (
      existingTagInfos !== null
      && existingTagInfos.length > 0
      && existingTagInfos[0].translation !== null
      && existingTagInfos[0].translation !== undefined
      && existingTagInfos[0].translation !== ''
    ) {
      setTermTranslated(existingTagInfos[0].translation);
    }
  }, [culture]);

  return termTranslated;
};

export default useTranslation;
